import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder for the customer shop list. Wraps the table <tbody>.
// On drop, sends the new id ordering to /customers/shops/reorder.
export default class extends Controller {
  static values = { url: String }
  static targets = ["item"]

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-shop-reorder-handle]",
      animation: 150,
      ghostClass: "opacity-40",
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    this.sortable?.destroy()
    this.sortable = null
  }

  async persist() {
    const ids = this.itemTargets
      .map(el => parseInt(el.dataset.shopId, 10))
      .filter(Number.isFinite)
    if (ids.length === 0) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken || ""
      },
      credentials: "same-origin",
      body: JSON.stringify({ ids })
    })
  }
}
